export default "__VITE_ASSET__Dqiu9FuH__"